import axios from '../../../axios';

const url = '/api/plan';

export const checkFeatureUsage = (feature: string) => axios.get(url + '/feature/usage/' + feature);
export const getCurrentUserWorkspacePlan = () => axios.get(url + '/workspace');
export const getPlanFeatureBalanceUsage = (featureCodes: string[]) => {
  const allFeatureCode = featureCodes.join('&featureCodes=');
  return axios.get(`${url}/feature/balance/usage?featureCodes=${allFeatureCode}`);
};
